import type { Idioma, NoDicionario } from './tipos';
import { dicionarios } from './dicionarios';

export type Variaveis = Record<string, string | number>;

function buscar(raiz: NoDicionario, chave: string): string | undefined {
  let no: string | NoDicionario | undefined = raiz;
  for (const segmento of chave.split('.')) {
    if (typeof no !== 'object' || no === null) return undefined;
    no = no[segmento];
  }
  return typeof no === 'string' ? no : undefined;
}

/** `Olá, {{nome}}` + `{ nome: 'Ana' }` → `Olá, Ana`. */
function interpolar(texto: string, variaveis?: Variaveis): string {
  if (!variaveis) return texto;
  return texto.replace(/\{\{\s*(\w+)\s*\}\}/g, (bruto, nome: string) =>
    nome in variaveis ? String(variaveis[nome]) : bruto
  );
}

/**
 * Resolve a chave no idioma pedido. Se falta tradução em inglês, cai no
 * português — a tela fica misturada, mas legível, o que é bem melhor do que
 * mostrar `apreciacoes.lista.titulo` para o usuário. Chave que não existe em
 * idioma nenhum é erro de digitação: devolve a própria chave e avisa no console
 * em desenvolvimento.
 */
export function traduzir(idioma: Idioma, chave: string, variaveis?: Variaveis): string {
  const noIdioma = buscar(dicionarios[idioma], chave);
  if (noIdioma !== undefined) return interpolar(noIdioma, variaveis);

  const emPortugues = idioma === 'pt' ? undefined : buscar(dicionarios.pt, chave);
  if (emPortugues !== undefined) {
    if (import.meta.env.DEV) console.warn(`[i18n] sem tradução ${idioma}: ${chave}`);
    return interpolar(emPortugues, variaveis);
  }

  if (import.meta.env.DEV) console.warn(`[i18n] chave inexistente: ${chave}`);
  return chave;
}
